<div class="overlay"> 
    <div class="content text-center m-b-20">
        <!-- progress-bar -->
        <div class="d-flex-center">
            <div class="progress-bar-container">
                <div class="progress-bar" [style.width]="progress + '%'"></div>
            </div>
        </div>

        <div class="font-h3">¡CANJEADO!</div>
        <div class="d-flex-center">
            <img src="assets/images/successRedeemed.gif" style="max-width: 250px;">
        </div> 
        <div class="font-h5" style="text-decoration: underline;" (click)="onClose()">Canjear de nuevo</div>
        <div class="font-h5" style="text-decoration: underline;" (click)="onShowExchanges()">Ver canjes</div>
        <audio #audioPlayer src="assets/audios/successredeemedsound2.mp3" autoplay></audio>
    </div>
</div>
